const KEY_PREFIX = "choirplayer:metadata:";

function keyForSong(songId) {
  return `${KEY_PREFIX}${songId}`;
}


export function deleteMetadataOverride(songId) {
  if (!songId) return;

  try {
    window.localStorage.removeItem(keyForSong(songId));
  } catch (e) {
    console.warn("Could not delete metadata override", songId, e);
  }
}


export function getMetadataOverride(songId) {
  if (!songId) return null;

  try {
    const raw = window.localStorage.getItem(keyForSong(songId));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.warn("Could not read metadata override", songId, e);
    return null;
  }
}

export function saveMetadataOverride(songId, data) {
  if (!songId) return;

  const existing = getMetadataOverride(songId) || {};

  window.localStorage.setItem(
    keyForSong(songId),
    JSON.stringify({
      ...existing,
      ...data,
      updatedAt: new Date().toISOString(),
    })
  );
}

export function applyMetadataOverrideToSong(song) {
  if (!song?.songId) return song;

  const override = getMetadataOverride(song.songId);
  if (!override) return song;

  return {
    ...song,
    chapters: Array.isArray(override.chapters) ? override.chapters : song.chapters,
    lyricsOverride: Array.isArray(override.lyrics) ? override.lyrics : song.lyricsOverride,
  };
}

function escapeXml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll('"', "&quot;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}

export function chaptersToXml(chapters) {
  const lines = (chapters || [])
    .map((chapter) => {
      return `  <chapter name="${escapeXml(chapter.name)}" time="${escapeXml(chapter.time)}" />`;
    })
    .join("\n");

  return `<?xml version="1.0" encoding="UTF-8"?>\n<chapters>\n${lines}\n</chapters>\n`;
}

export function lyricsToXml(lyrics) {
  const lines = (lyrics || [])
    .map((line) => {
      return `  <line time="${escapeXml(line.time)}">${escapeXml(line.text)}</line>`;
    })
    .join("\n");

  return `<?xml version="1.0" encoding="UTF-8"?>\n<lyrics>\n${lines}\n</lyrics>\n`;
}

export function downloadTextFile(filename, text) {
  const blob = new Blob([text], { type: "application/xml;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();

  URL.revokeObjectURL(url);
}

